import React, { useState } from "react";
import { Link } from "react-router-dom";
import { authAPI } from "../services/api";
import { useI18n } from "../i18n";
import AuthShell, { buttonClass, inputClass } from "../components/AuthShell";

/**
 * Asks for a reset link. Whatever the address, the answer is the same — the
 * server does not say whether an account exists, and neither does this screen.
 */
const ForgotPassword = () => {
  const { t, lang } = useI18n();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError("");

    try {
      await authAPI.forgotPassword(email, lang);
      setSent(true);
    } catch (err) {
      setError(
        err.response?.status === 429
          ? err.response.data.error
          : t("auth.login.failed"),
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title={t("auth.forgot.title")}>
      {sent ? (
        <p className="p-4 bg-green-50 border border-green-200 rounded-lg text-green-800 text-sm">
          {t("auth.forgot.sent")}
        </p>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <p className="text-sm text-gray-600">{t("auth.forgot.intro")}</p>

          {error && (
            <p className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm">
              {error}
            </p>
          )}

          <div>
            <label htmlFor="forgot-1" className="block text-sm font-medium text-gray-700 mb-2">
              {t("auth.forgot.email")}
            </label>
            <input id="forgot-1"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
              dir="ltr"
              className={inputClass}
            />
          </div>

          <button type="submit" disabled={busy} className={buttonClass}>
            {busy ? t("auth.forgot.sending") : t("auth.forgot.submit")}
          </button>
        </form>
      )}

      <p className="mt-6 text-center text-sm">
        <Link to="/login" className="text-primary-600 hover:underline">
          {t("auth.forgot.back")}
        </Link>
      </p>
    </AuthShell>
  );
};

export default ForgotPassword;
